import React from 'react'
import cn from 'classnames'
import sLay from 'styles/modules/layout.scss'
import sText from 'components/Text/Text.scss'
import { Link } from 'react-router'
import IconArrowRight from 'components/Icons/ArrowRight'
import sMarg from 'styles/modules/margins.scss'

export default ({ text, path }) => (
  <div className={cn(sLay['layout-row'], sLay['layout-align-center-center'], sMarg.mt60to30)}>
    <Link to={path} className={sText.heading4}>
      {text}
    </Link>
    <IconArrowRight size={30} style={{ marginLeft: '10px' }} />
  </div>
)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/ArrowLink/ArrowLink.jsx